import Client from './Client';

export default class PointsClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取机构积分列表
   */
  async getAgencyPointsList(data) {
    const res = await this.client.post('/api/points/pageAgencyPoints', data);
    return res;
  }

  /**
   * 获取商品列表
   */
  async getPagePointsProduct(data) {
    const res = await this.client.post('/api/points/pagePointsProduct', data);
    return res;
  }

  /**
   * 商品 上架 下架
   */
  async updateValidPointsProduct(data) {
    const res = await this.client.post('/api/points/updateValidPointsProduct', data);
    return res;
  }

  /**
   * 商品购买列表
   */
  async getPageOrder(data) {
    const res = await this.client.post('/api/points/pageOrder', data);
    return res;
  }

  /**
   * 查询辅导员抵用券
   */
  async counselorCouponQuery(data) {
    const res = await this.client.post('/api/points/counselorCouponQuery', data);
    return res;
  }

  /**
   * 使用辅导员抵用券
   */
  async useCounselorCoupon(data) {
    const res = await this.client.post('/api/points/useCounselorCoupon', data);
    return res;
  }

  /**
   * 查询机构积分
   */
  async getAgencyPoints(data) {
    const res = await this.client.post('/api/points/getAgencyPoints', data);
    return res;
  }

  /**
   * 查询机构积分使用记录
   */
  async pageAgencyPointsRecord(data) {
    const res = await this.client.post('/api/points/pageAgencyPointsRecord', data);
    return res;
  }

  /**
   * 新增修改商品
   */
  async upsertPointsProduct(data) {
    const res = await this.client.post('/api/points/upsertPointsProduct', data);
    return res;
  }

  /**
   * 有直播的课程
   */
  async listNameByLive(data) {
    const res = await this.client.post('/api/course/listNameByLive', data);
    return res;
  }

  /**
   * 获取母课程下拉
   */
  async listCourseClassName(data) {
    const res = await this.client.post('/api/course/listCourseClassName', data);
    return res;
  }
}